var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":_vm.editModal.id,"title":"Edit Time Entry","hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":"","centered":""}},[_c('EditTimer',{attrs:{"previewItem":_vm.editModal.item,"modalId":_vm.editModal.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }